import { Icon } from '@design-system';
import classNames from 'classnames';
import { FC, useState } from 'react';

import { Ratio } from '../../helpers/images';
import { AspectRatio } from '../AspectRatio/AspectRatio';
import { Image } from '../Image';

interface VideoPlayerProps {
  baseUrl: string;
  handlePlay: () => void;
  poster: string;
  title: string;
  ratio: {
    sm: Ratio;
    md?: Ratio;
    lg?: Ratio;
  };
  videoId: string | number;
}

export const VideoPlayer: FC<VideoPlayerProps> = ({
  baseUrl,
  handlePlay,
  poster,
  ratio,
  title,
  videoId,
}) => {
  const [showCover, setShowCover] = useState(Boolean(poster));

  return (
    <AspectRatio
      className={classNames('mx-auto h-full overflow-hidden rounded-sm')}
      lg={ratio.lg}
      md={ratio.md}
      sm={ratio.sm}
    >
      {showCover ? (
        <button
          className="group h-full w-full"
          onClick={() => {
            handlePlay();
            setShowCover(false);
          }}
          type="button"
        >
          <Image
            alt={title}
            hoverEffect
            size={{
              sm: { ratio: ratio.sm, span: 12 },
              md: { ratio: ratio.md || ratio.sm, span: 4 },
              lg: { ratio: ratio.lg || ratio.sm, span: 4 },
            }}
            src={poster}
          />
          <span className="pointer-events-none absolute inset-0 flex items-center justify-center bg-neutral-6/10">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-white">
              <Icon name="ic_play" size="lg" />
            </span>
          </span>
        </button>
      ) : (
        <iframe
          allow="autoplay"
          allowFullScreen
          className="h-full w-full"
          src={`${baseUrl}${videoId}?autoplay=1`}
          title={title}
        />
      )}
    </AspectRatio>
  );
};
